import { useContent } from "@/lib/content";
import { Seo } from "@/components/Seo";
import { Overline } from "@/components/Overline";

export default function Datenschutz() {
  const c = useContent();
  return (
    <div data-testid="datenschutz-page" className="bg-cream min-h-screen">
      <Seo page="contact" />
      <section className="pt-44 pb-12 bg-sand grain relative">
        <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
          <Overline className="!flex justify-center">Rechtliches</Overline>
          <h1 className="font-serif font-light text-5xl sm:text-6xl text-ink tracking-tight">Datenschutz</h1>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6">
          <p className="text-ink-soft font-light leading-relaxed whitespace-pre-line">{c.text.legal.datenschutz}</p>
        </div>
      </section>
    </div>
  );
}
